import adminTable from '@store/adminTable/reducers';

import { options } from '@Modules/Options/configs/constants';

export default adminTable(options);
